import { render } from "./editWristBandAccessoryModal.vue?vue&type=template&id=13a188ba&scoped=true&ts=true"
import script from "./editWristBandAccessoryModal.vue?vue&type=script&lang=ts"
export * from "./editWristBandAccessoryModal.vue?vue&type=script&lang=ts"

import "./editWristBandAccessoryModal.vue?vue&type=style&index=0&id=13a188ba&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13a188ba"]])

export default __exports__